import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

const modalRoot = document.getElementById('modal-root');

class Modal extends React.PureComponent {

    constructor(props) {

        super(props);

        this.el = document.createElement('div');

        this.modalRef = React.createRef();

        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleDocumentKeyUp = this.handleDocumentKeyUp.bind(this);
    }

    afterRender() {

        // Bootstrap requires a class on the body element to show an open modal.

        document.body.classList.toggle('modal-open', this.props.show);

        _.defer(() => {

            // Add a nice animation to show the modal.

            this.modalRef.current.classList.toggle('show', this.props.show);

            if (this.props.show && this.props.onShow)
                this.props.onShow();
        });
    }

    componentDidMount() {

        modalRoot.appendChild(this.el);
        document.addEventListener('keyup', this.handleDocumentKeyUp);

        this.afterRender();
    }

    componentDidUpdate(prevProps) {

        if (this.props.show !== prevProps.show)
            this.afterRender();
    }

    componentWillUnmount() {

        modalRoot.removeChild(this.el);
        document.removeEventListener('keyup', this.handleDocumentKeyUp);
    }

    handleCloseClick(e) {

        if (this.props.onClose)
            this.props.onClose(e);
    }

    handleDocumentKeyUp(e) {

        if (e.keyCode === 27) { // Esc

            e.preventDefault();
            this.handleCloseClick();
        }
    }

    render() {

        const contents = (

            <div ref={this.modalRef}
                 className="modal fade"
                 tabIndex="-1"
                 role="dialog"
                 style={{display: this.props.show ? 'block' : 'none'}}
                 onClick={this.handleCloseClick}>

                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content rounded border shadow" onClick={e => e.stopPropagation()}>

                        <div className="modal-header">
                            <h5 className="modal-title">{this.props.title}</h5>
                            <button type="button" className="close" onClick={this.handleCloseClick}>
                                <i className="fas fa-times"/>
                            </button>
                        </div>

                        <div className="modal-body">
                            {this.props.children}
                        </div>

                        {this.props.footerChildren && (

                            <div className="modal-footer">
                                {this.props.footerChildren}
                            </div>
                        )}

                    </div>
                </div>

            </div>
        );

        return ReactDOM.createPortal(contents, this.el);
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modals/Modal.js